import { useState } from 'react';
import { supabase } from '@/lib/supabase';
import { mensagemAmigavel } from '@/lib/mensagemAmigavel';
import Modal from '@/components/ui/Modal';
import Botao from '@/components/ui/Botao';
import Campo from '@/components/ui/Campo';
import type { Repasse } from '../types';

interface Props {
  repasse: Repasse;
  aoFechar: () => void;
  aoFeito: (recado: string) => void;
}

export default function ModalDesfazerRepasse({ repasse, aoFechar, aoFeito }: Props) {
  const [motivo, setMotivo] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function desfazer() {
    setErro(null);
    if (!motivo.trim()) {
      setErro('Escreva o motivo para desfazer.');
      return;
    }
    setEnviando(true);
    try {
      const { data, error } = await supabase.rpc('plataforma_desfazer_repasse', {
        p_id: repasse.id,
        p_motivo: motivo.trim(),
      });
      if (error) throw error;

      const r = data as { ok?: boolean; recado?: string; erro?: string } | null;
      if (r?.ok === false) {
        setErro(r?.erro ?? 'Não foi possível desfazer.');
        return;
      }
      aoFeito(r?.recado ?? 'Repasse desfeito.');
    } catch (e) {
      setErro(mensagemAmigavel(e));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <Modal aberto titulo="Desfazer repasse" aoFechar={aoFechar}>
      <p className="text-sm text-foreground-700">
        O repasse fica riscado no histórico e o saldo volta como era. Isto não mexe no banco.
      </p>

      <div className="mt-4 space-y-4">
        <Campo
          rotulo="Motivo"
          value={motivo}
          onChange={setMotivo}
          placeholder="ex.: valor digitado errado"
        />

        {erro && (
          <p className="flex items-start gap-1.5 text-sm text-danger-600" role="alert">
            <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
              <i className="ri-error-warning-line" />
            </span>
            <span className="min-w-0">{erro}</span>
          </p>
        )}

        <div className="flex flex-col-reverse gap-2 sm:flex-row">
          <Botao variante="secundario" cheio onClick={aoFechar}>
            Cancelar
          </Botao>
          <Botao variante="perigo" carregando={enviando} onClick={desfazer} cheio>
            Desfazer
          </Botao>
        </div>
      </div>
    </Modal>
  );
}